(ns ycweb.app.website.products.components.notify-me
  (:require
   [rum.core :as rum]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.components.forms :as forms]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.headings :as headings]
   [ycweb.components.appcommon :as appcommon]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [util.string :as str]))

(defn- eligible-variations [product]
  (->> (vals (:variations product))
    (filter #(= (get-in % [:variation/stockmessage :stock/show-notify]) "Yes"))))

(defn- variation-label [{variation-name :variation/name :variation/keys [feature1 feature2]}]
  (let [parts (remove str/blank? [variation-name feature1 feature2])]
    (str/join " - " parts)))

(rum/defc notify-me-modal-header < rum/reactive [app-atom config-atom m-config]
  [:div.modal__header
   (headings/heading "Notify me when this item is available"
     {:flush true
      :class "modal__heading"
      :size :default})])

(rum/defc notify-me-modal-body < rum/reactive [app-atom config-atom m-config]
  (let [{:keys [state product-id message]
         eligible :eligible-variations}
        (cmn/curact config-atom [:config])]
    (case state
      :loading
      [:div.u-text-center.u-padding-20
       [:p.yc-paragraph "Submitting your request…"]
       [:div.loading-spinner]]

      :success
      [:div.u-text-center.u-padding-20
       (feedback/feedback :success "Request received"
         (or message "We'll send you an email when this item becomes available.")
         nil nil nil nil)]

      [:div
       (when (= state :info)
         [:div.u-margin-bottom-16
          (feedback/feedback :info nil
            (or message "We already have your details on hand for this product.")
            nil nil nil nil)])

       (forms/input "Email address: (required)" "e.g. jane.smith@domain.com"
         (rum/cursor-in config-atom [:config :email])
         {:type :email :auto-focus (cmn/auto-focus? app-atom)})

       (forms/input "Contact number: (optional)" "e.g. 0821234567"
         (rum/cursor-in config-atom [:config :tel])
         {:type :phone})

       (forms/input "Your name: (optional)" "e.g. Jane Smith"
         (rum/cursor-in config-atom [:config :fullname])
         {})

       [:div.form-field
        [:label.form-label "Product:"]
        [:select.select
         {:value (or (cmn/curact (rum/cursor-in config-atom [:config]) :variation-id) "")
          :on-change
          (fn [e]
            (let [v (.-value (.-target e))]
              (swap! (rum/cursor-in config-atom [:config])
                assoc :variation-id (when (seq v) v))))}
         [:option {:value ""} "When any variations become available"]
         (for [v eligible]
           [:option {:key (:variation/id v) :value (str (:variation/id v))}
            (variation-label v)])]]

       [:div#notify-extra-details
        [:div.form-field
         (forms/checkbox "Sign up to our newsletter"
           (rum/cursor-in config-atom [:config :newsletter])
           {:id "notifyNewsletter"
            :description "Be the first to know about our famous Tick Tick Tuesday deals and tempting new product releases."})]

        [:div.form-field
         (forms/checkbox "Personalised offers"
           (rum/cursor-in config-atom [:config :promotions])
           {:id "notifyPromotions"
            :description "Receive personalised vouchers or special offers for Yuppiechef, sent no more than a few times a year."})]]])))

(rum/defc notify-me-modal-footer < rum/reactive [app-atom config-atom m-config]
  (let [{:keys [email state]} (cmn/curact config-atom [:config])
        captcha-site-key (get-in @app-atom [:config :captcha-site-key])
        has-email? (u/presence email)
        show-form? (contains? #{:form :info} state)]
    (when show-form?
      (grid/button-row
        {:single-text "Notify Me"
         :single-style :primary
         :single-fn
         (fn []
           (if captcha-site-key
             (appcommon/recaptcha app-atom captcha-site-key
               :web.product/notify-me-submit
               (:config @config-atom))
             (grid/dispatch-action app-atom
               :web.product/notify-me-submit
               (:config @config-atom))))
         :single-disabled? (not has-email?)}))))

(defmethod grid/modal-config :web.product/notify-me-modal [_ _ _]
  {:body-raw notify-me-modal-header
   :body notify-me-modal-body
   :footer notify-me-modal-footer
   :modal-type :variable
   :max-width "480"})

(defn open-notify-me-modal
  "Open the notify-me modal for a product. Pre-fills user data if logged in."
  [app-atom product variation]
  (let [user (get-in @app-atom [:user])
        eligible (eligible-variations product)]
    (grid/open-modal app-atom :web.product/notify-me-modal
      {:config
       {:email (or (:email user) "")
        :tel ""
        :fullname
        (if user
          (str/trim (str (or (:firstname user) "") " " (or (:lastname user) "")))
          "")
        :variation-id (str (:variation/id variation))
        :newsletter true
        :promotions true
        :state :form
        :product-id (:id product)
        :eligible-variations eligible}})))

(defmethod grid/action :web.product/notify-me-submit [app-atom config _]
  (let [{:keys [email tel fullname variation-id newsletter promotions
                product-id captcha-token]} config]
    (grid/update-modal-config app-atom :web.product/notify-me-modal
      {:config (assoc config :state :loading)})
    (comms/ajax-post :web.product/notify-me-submit
      {:captcha-token captcha-token
       :contentid product-id
       :email email
       :tel tel
       :name fullname
       :variationid variation-id
       :newsletter (if newsletter "1" "0")
       :promotions (if promotions "1" "0")})))

(defmethod comms/receive :web.product/notify-me-submit [app-atom e]
  (let [modal-atom (grid/modal-cursor app-atom)
        current-config (get-in @modal-atom [:config :config])]
    (if (:notify? e)
      (grid/update-modal-config app-atom :web.product/notify-me-modal
        {:config {:state :success
                  :message (:message e)}})
      (grid/update-modal-config app-atom :web.product/notify-me-modal
        {:config (assoc current-config
                   :state :info
                   :message (or (:message e) "Please try again later."))}))))
